import type { Locale } from '@packages/config';

import { getCmsDataCacheKey } from './getCmsDataCacheKey';
import { getUspEndpoint } from './getUspEndpoint';

export const getUspFetchParams = (locale: Locale): { endpoint: string; cacheKey: string } => ({
  endpoint: getUspEndpoint(locale),
  cacheKey: getCmsDataCacheKey('usp', locale),
});
